
import { mapState, mapGetters, mapActions } from 'vuex';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
export default {
  name: 'AppReviewScoreSectionList',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('review', ['showDate', 'showEditOrDelete', 'showScore']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    editOrDeleteOptions() {
      return [
        this.review.editable
          ? { name: this.$t('app.edit_review'), value: 'edit' }
          : null,
        this.review.deletable
          ? {
              name: this.$t('app.delete_review'),
              value: 'delete',
              danger: true
            }
          : null
      ].filter(v => v);
    }
  },
  methods: {
    ...mapActions('review', ['handleEditOrDeleteReview'])
  }
};
